module.exports = __webpack_public_path__ + "img/daren.8442b655.jpeg";